<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-jiuyuanduiwu`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_c78bb9f932__clip0_1270_102729)"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.875 5.625C4.875 4.58947 5.71447 3.75 6.75 3.75C7.78553 3.75 8.625 4.58947 8.625 5.625C8.625 6.66053 7.78553 7.5 6.75 7.5C5.71447 7.5 4.875 6.66053 4.875 5.625ZM6.75 2.25C4.88604 2.25 3.375 3.76104 3.375 5.625C3.375 7.48896 4.88604 9 6.75 9C8.61396 9 10.125 7.48896 10.125 5.625C10.125 3.76104 8.61396 2.25 6.75 2.25ZM12 7.125C12 6.71079 12.3358 6.375 12.75 6.375C13.1642 6.375 13.5 6.71079 13.5 7.125C13.5 7.53921 13.1642 7.875 12.75 7.875C12.3358 7.875 12 7.53921 12 7.125ZM12.75 4.875C11.5074 4.875 10.5 5.88236 10.5 7.125C10.5 8.36764 11.5074 9.375 12.75 9.375C13.9926 9.375 15 8.36764 15 7.125C15 5.88236 13.9926 4.875 12.75 4.875ZM1.5 12.75C1.5 11.0931 2.84315 9.75 4.5 9.75H9C10.6569 9.75 12 11.0931 12 12.75V15.75H1.5V12.75ZM4.5 11.25C3.67157 11.25 3 11.9216 3 12.75V14.25H10.5V12.75C10.5 11.9216 9.82843 11.25 9 11.25H4.5ZM16.5 12.75C16.5 11.5074 15.4926 10.5 14.25 10.5H12.75V12H14.25C14.6642 12 15 12.3358 15 12.75V13.5H12.75V15H16.5V12.75Z"/></g><defs><clipPath id="svg_c78bb9f932__clip0_1270_102729"><path d="M0 0H18V18H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconJiuyuanduiwu',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
